import sideboard_walnut_197x139 from '../assets/product-images/sideboard_walnut_197x139.png'
import sideboard_oak_236x116 from '../assets/product-images/sideboard_oak_236x116.png'
import sideboard_white_oak_80x108 from '../assets/product-images/sideboard_white_oak_80x108.png'

import bookcase_oak_200x170 from '../assets/product-images/bookcase_oak_200x170.png'
import bookcase_whiteoak_247x187 from '../assets/product-images/bookcase_whiteoak_247x187.png'

import wallstorage_walnut_184x200 from '../assets/product-images/wallstorage_walnut_184x200.png'
import wallstorage_oak_180x126 from '../assets/product-images/wallstorage_oak_180x126.png'
import wallstorage_black_204x136 from '../assets/product-images/wallstorage_black_204x136.png'

import wardrobe_oak_236x360 from '../assets/product-images/wardrobe_oak_236x360.png'

import bedside_table_walnut_138x102 from '../assets/product-images/bedside_table_walnut_138x102.png'
import bedside_table_oak_80x54 from '../assets/product-images/bedside_table_oak_80x54.png'
import bedside_table_black_54x67 from '../assets/product-images/bedside_table_black_54x67.png'

import tvstand_walnut_169x80 from '../assets/product-images/tvstand_walnut_169x80.png'
import tvstand_oak_163x54 from '../assets/product-images/tvstand_oak_163x54.png'
import tvstand_whiteoak_105x49 from '../assets/product-images/tvstand_whiteoak_105x49.png'

import shoerack_oak_175x120 from '../assets/product-images/shoerack_oak_175x120.png'
import shoerack_white_and_red_200x240 from '../assets/product-images/shoerack_white_and_red_200x240.png'

import vinyl_storage_walnut_249x136 from '../assets/product-images/vinyl_storage_walnut_249x136.png'
import vinyl_storage_oak_153x111 from '../assets/product-images/vinyl_storage_oak_153x111.png'
import vinyl_storage_black_155x111 from '../assets/product-images/vinyl_storage_black_155x111.png'
import vinyl_storage_white_123x111 from '../assets/product-images/vinyl_storage_white_123x111.png'

import desk_walnut_160x90 from '../assets/product-images/desk_walnut_160x90.png'
import desk_whiteoak_105x110 from '../assets/product-images/desk_whiteoak_105x110.png'

export const data = [
  {
    displayName: 'Sideboard in walnut',
    description: 'Sideboard in walnut',
    image: sideboard_walnut_197x139,
    type: 'sideboard',
    id: '66a7e3f0ce9c11b66d2a69d4',
    url: 'https://vectraxd.com/published/ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmtaWE5wWjI1SlpDSTZJalkyWVRkbE0yWXdZMlU1WXpFeFlqWTJaREpoTmpsa05DSXNJbkJ5YjJwbFkzUkpaQ0k2SWpZMllUUmlPV1E1WTJVNVl6RXhZalkyWkRKaE5qWTNZeUlzSW1saGRDSTZNVGMwT0RZNU5USXpOU3dpWlhod0lqb3hOemd3TWpNeE1qTTFmUS5LTmI4ZE85WlJRWE14NVJpX2lTV2QwZHVLZ3lDOUxxNW9INS1ZTkk1UUhF',
    size: '197 x 139 cm',
    make: 'Organic Classic',
    isTopSeller: true,
  },
  {
    displayName: 'Sideboard in oak with drawers and doors',
    description: 'Sideboard in oak with drawers and doors',
    image: sideboard_oak_236x116,
    type: 'sideboard',
    id: '66a7e42dce9c11b66d2a69d7',
    url: 'https://vectraxd.com/published/ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmtaWE5wWjI1SlpDSTZJalkyWVRkbE5ESmtZMlU1WXpFeFlqWTJaREpoTmpsa055SXNJbkJ5YjJwbFkzUkpaQ0k2SWpZMllUUmlPV1E1WTJVNVl6RXhZalkyWkRKaE5qWTNZeUlzSW1saGRDSTZNVGMwT0RZNU5UUTBNQ3dpWlhod0lqb3hOemd3TWpNeE5EUXdmUS5NcG9FUHVoUnpQdmpqVTB3Ul93YjZZdlhGOTBwMkJTbEVmc1JTVXBOMENF',
    size: '236 x 116 cm',
    make: 'Organic Classic',
    isTopSeller: false,
  },
  {
    displayName: 'Sideboard in white oak with drawers',
    description: 'Sideboard in white oak with drawers',
    image: sideboard_white_oak_80x108,
    type: 'sideboard',
    id: '66b0a8ffce9c11b66d2a8c98',
    url: 'https://vectraxd.com/published/ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmtaWE5wWjI1SlpDSTZJalkyWWpCaE9HWm1ZMlU1WXpFeFlqWTJaREpoT0dNNU9DSXNJbkJ5YjJwbFkzUkpaQ0k2SWpZMllUUmlPV1E1WTJVNVl6RXhZalkyWkRKaE5qWTNZeUlzSW1saGRDSTZNVGMwT0RZNU5UTTBPQ3dpWlhod0lqb3hOemd3TWpNeE16UTRmUS5VTUlNZGhJMUEzdTFycGFIc1JCUl9Na1Ruamo0VVZJMDBKSkYwdUFlVU04',
    size: '80 x 108 cm',
    make: 'Organic Classic',
    isTopSeller: false,
  },
  {
    displayName: 'Bookcase in oak',
    description: 'Bookcase in oak',
    image: bookcase_oak_200x170,
    type: 'bookcase',
    id: '66a7fb85ce9c11b66d2a6c16',
    url: 'https://vectraxd.com/published/ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmtaWE5wWjI1SlpDSTZJalkyWVRkbVlqZzFZMlU1WXpFeFlqWTJaREpoTm1NeE5pSXNJbkJ5YjJwbFkzUkpaQ0k2SWpZMllUUmlPV1E1WTJVNVl6RXhZalkyWkRKaE5qWTNZeUlzSW1saGRDSTZNVGMwT0RZNU5UUTRNU3dpWlhod0lqb3hOemd3TWpNeE5EZ3hmUS5pOTBNazJxV1pSLUZHM09ZTnR5bU1WOEFEbkt4dnlaTE1YRVpldUh5SHI4',
    size: '200 x 170 cm',
    make: 'Organic Classic',
    isTopSeller: true,
  },
  {
    displayName: 'Bookcase in white oak',
    description: 'Bookcase in white oak',
    image: bookcase_whiteoak_247x187,
    type: 'bookcase',
    id: '66a868ddce9c11b66d2a6c81',
    url: 'https://vectraxd.com/published/ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmtaWE5wWjI1SlpDSTZJalkyWVRnMk9HUmtZMlU1WXpFeFlqWTJaREpoTm1NNE1TSXNJbkJ5YjJwbFkzUkpaQ0k2SWpZMllUUmlPV1E1WTJVNVl6RXhZalkyWkRKaE5qWTNZeUlzSW1saGRDSTZNVGMwT0RZNU5UVTBOU3dpWlhod0lqb3hOemd3TWpNeE5UUTFmUS5kYm1JUU5OTWt6RGpVbjVsV002YjNzTU1NWFNNcVN2SFVoRFNEeDEyN3Qw',
    size: '247 x 187 cm',
    make: 'Organic Classic',
    isTopSeller: true,
  },
  {
    displayName: 'Wall storage in walnut',
    description: 'Wall storage in walnut',
    image: wallstorage_walnut_184x200,
    type: 'wall_storage',
    id: '66a892b5ce9c11b66d2a70cc',
    url: 'https://vectraxd.com/published/ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmtaWE5wWjI1SlpDSTZJalkyWVRnNU1tSTFZMlU1WXpFeFlqWTJaREpoTnpCall5SXNJbkJ5YjJwbFkzUkpaQ0k2SWpZMllUUmlPV1E1WTJVNVl6RXhZalkyWkRKaE5qWTNZeUlzSW1saGRDSTZNVGMwT0RZNU5UVTROaXdpWlhod0lqb3hOemd3TWpNeE5UZzJmUS5oTFZINXdrNXpnUUNGTVMtay1qRUw2U20tQXhjRUF3bklQT0stTGZOUnhF',
    size: '184 x 200 cm',
    make: 'Organic Classic',
    isTopSeller: true,
  },
  {
    displayName: 'Wall storage in oak',
    description: 'Wall Storage in Oak with drawers and doors',
    image: wallstorage_oak_180x126,
    type: 'wall_storage',
    id: '66a89bf1ce9c11b66d2a7190',
    url: 'https://vectraxd.com/published/ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmtaWE5wWjI1SlpDSTZJalkyWVRnNVltWXhZMlU1WXpFeFlqWTJaREpoTnpFNU1DSXNJbkJ5YjJwbFkzUkpaQ0k2SWpZMllUUmlPV1E1WTJVNVl6RXhZalkyWkRKaE5qWTNZeUlzSW1saGRDSTZNVGMwT0RZNU5UWXhNU3dpWlhod0lqb3hOemd3TWpNeE5qRXhmUS5mblg3akVkSkt4V09Vc285UnZoV3pNb25odmhnQXJNR1hRU0t0UEx5ODI0',
    size: '180 x 126 cm',
    make: 'Organic Classic',
    isTopSeller: true,
  },
  {
    displayName: 'Wall storage in black grey plywood',
    description: 'Wall storage in black grey plywood',
    image: wallstorage_black_204x136,
    type: 'wall_storage',
    id: '66a8a3ddce9c11b66d2a72a4',
    url: 'https://vectraxd.com/published/ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmtaWE5wWjI1SlpDSTZJalkyWVRoaE0yUmtZMlU1WXpFeFlqWTJaREpoTnpKaE5DSXNJbkJ5YjJwbFkzUkpaQ0k2SWpZMllUUmlPV1E1WTJVNVl6RXhZalkyWkRKaE5qWTNZeUlzSW1saGRDSTZNVGMwT0RZNU5UWTNNeXdpWlhod0lqb3hOemd3TWpNeE5qY3pmUS5GUFQxLW0zRWJtalVwVTdMS1ZIN1dmeGFZVzVpRFlvNjA4MEdwUFQ1bzFZ',
    size: '204 x 136 cm',
    make: 'Organic Modern',
    isTopSeller: false,
  },

  {
    displayName: 'Wardrobe in oak',
    description: 'Wardrobe with drawers and multiple planks',
    image: wardrobe_oak_236x360,
    type: 'wardrobe',
    id: '66a8cdc8ce9c11b66d2a73c2',
    url: 'https://vectraxd.com/published/ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmtaWE5wWjI1SlpDSTZJalkyWVRoalpHTTRZMlU1WXpFeFlqWTJaREpoTnpOak1pSXNJbkJ5YjJwbFkzUkpaQ0k2SWpZMllUUmlPV1E1WTJVNVl6RXhZalkyWkRKaE5qWTNZeUlzSW1saGRDSTZNVGMwT0RZNU5UY3lNaXdpWlhod0lqb3hOemd3TWpNeE56SXlmUS51SzlvakZZX3pKdEVWQWliem9FX21yNEQ0SVVGVHR1QWxYcFdPaWhmcFkw',
    size: '236 x 360 cm',
    make: 'Organic Modern',
    isTopSeller: false,
  },
  {
    displayName: 'Desk in white oak',
    description: 'Desk in white oak',
    image: desk_whiteoak_105x110,
    type: 'desk',
    id: '66ab2eebce9c11b66d2a7f18',
    url: 'https://vectraxd.com/published/ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmtaWE5wWjI1SlpDSTZJalkyWVdJeVpXVmlZMlU1WXpFeFlqWTJaREpoTjJZeE9DSXNJbkJ5YjJwbFkzUkpaQ0k2SWpZMllUUmlPV1E1WTJVNVl6RXhZalkyWkRKaE5qWTNZeUlzSW1saGRDSTZNVGMwT0RZNU5UYzJNaXdpWlhod0lqb3hOemd3TWpNeE56WXlmUS4xYUN0d0xISEgzSEplVV82cFpXT0dSNFlOMGpHZlJVU1lscVhfaDZ2eDBz',
    size: '105 x 110 cm',
    make: 'Organic Modern',
    isTopSeller: true,
  },
  {
    displayName: 'Desk in walnut',
    description: 'Desk layout in walnut',
    image: desk_walnut_160x90,
    type: 'desk',
    id: '66ab46c0ce9c11b66d2a8272',
    url: 'https://vectraxd.com/published/ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmtaWE5wWjI1SlpDSTZJalkyWVdJME5tTXdZMlU1WXpFeFlqWTJaREpoT0RJM01pSXNJbkJ5YjJwbFkzUkpaQ0k2SWpZMllUUmlPV1E1WTJVNVl6RXhZalkyWkRKaE5qWTNZeUlzSW1saGRDSTZNVGMwT0RZNU5UZ3dPQ3dpWlhod0lqb3hOemd3TWpNeE9EQTRmUS52XzhYWG9rcmVXV0hFb3NhQ2htR2hkdmQwOE9MMGkydXpQX1FuQU5CYTFV',
    size: '160 x 90 cm',
    make: 'Organic Classic',
    isTopSeller: true,
  },
  {
    displayName: 'TV stand in walnut',
    description: 'TV stand in walnut',
    image: tvstand_walnut_169x80,
    type: 'tv_stand',
    id: '66ab261bce9c11b66d2a7e52',
    url: 'https://vectraxd.com/published/ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmtaWE5wWjI1SlpDSTZJalkyWVdJeU5qRmlZMlU1WXpFeFlqWTJaREpoTjJVMU1pSXNJbkJ5YjJwbFkzUkpaQ0k2SWpZMllUUmlPV1E1WTJVNVl6RXhZalkyWkRKaE5qWTNZeUlzSW1saGRDSTZNVGMwT0RZNU5UZzFPQ3dpWlhod0lqb3hOemd3TWpNeE9EVTRmUS4xeGN1YmQyTW1rNWNraGNPa0RqWS1td3hFZ0UwWVJyanp6OTN3c1dwT3Rz',
    size: '169 x 80 cm',
    make: 'Organic Modern',
    isTopSeller: true,
  },
  {
    displayName: 'TV stand in oak',
    description: 'TV stand in oak',
    image: tvstand_oak_163x54,
    type: 'tv_stand',
    id: '66ab286fce9c11b66d2a7e85',
    url: 'https://vectraxd.com/published/ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmtaWE5wWjI1SlpDSTZJalkyWVdJeU9EWm1ZMlU1WXpFeFlqWTJaREpoTjJVNE5TSXNJbkJ5YjJwbFkzUkpaQ0k2SWpZMllUUmlPV1E1WTJVNVl6RXhZalkyWkRKaE5qWTNZeUlzSW1saGRDSTZNVGMwT0RZNU5UZzROQ3dpWlhod0lqb3hOemd3TWpNeE9EZzBmUS5UYVJDbF81azNuU2RDM2s5S0FkLVVyaXVqRlhpSHVuOXZYc3FKQWZCcmVZ',
    size: '163 x 54 cm',
    make: 'Organic Modern',
    isTopSeller: true,
  },
  {
    displayName: 'TV stand in white oak',
    description: 'TV stand in white oak',
    image: tvstand_whiteoak_105x49,
    type: 'tv_stand',
    id: '66ab28aace9c11b66d2a7e88',
    url: 'https://vectraxd.com/published/ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmtaWE5wWjI1SlpDSTZJalkyWVdJeU9HRmhZMlU1WXpFeFlqWTJaREpoTjJVNE9DSXNJbkJ5YjJwbFkzUkpaQ0k2SWpZMllUUmlPV1E1WTJVNVl6RXhZalkyWkRKaE5qWTNZeUlzSW1saGRDSTZNVGMwT0RZNU5UZzVOaXdpWlhod0lqb3hOemd3TWpNeE9EazJmUS5JTlBDanJ0Y0xOQ3JYWko5NnlPakl5MG54TnNtNUQzR3hDd0NuaEFCeThr',
    size: '105 x 49 cm',
    make: 'Organic Modern',
    isTopSeller: true,
  },
  {
    displayName: 'Shoe rack in oak',
    description: 'Shoe rack in oak',
    image: shoerack_oak_175x120,
    type: 'shoe_rack',
    id: '66a9d4e1ce9c11b66d2a765d',
    url: 'https://vectraxd.com/published/ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmtaWE5wWjI1SlpDSTZJalkyWVRsa05HVXhZMlU1WXpFeFlqWTJaREpoTnpZMVpDSXNJbkJ5YjJwbFkzUkpaQ0k2SWpZMllUUmlPV1E1WTJVNVl6RXhZalkyWkRKaE5qWTNZeUlzSW1saGRDSTZNVGMwT0RZNU5UazBNU3dpWlhod0lqb3hOemd3TWpNeE9UUXhmUS44UF9EMGhKVnlRalA4UDVOb1lNNGtqM3ZSdkFpeVhFRjZTZzRfbG1NdERz',
    size: '175 x 120 cm',
    make: 'Organic Modern',
    isTopSeller: true,
  },
  {
    displayName: 'Shoe rack in white and red color',
    description: 'Shoe rack in white and red color',
    image: shoerack_white_and_red_200x240,
    type: 'shoe_rack',
    id: '66aa074cce9c11b66d2a787e',
    url: 'https://vectraxd.com/published/ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmtaWE5wWjI1SlpDSTZJalkyWVdFd056UmpZMlU1WXpFeFlqWTJaREpoTnpnM1pTSXNJbkJ5YjJwbFkzUkpaQ0k2SWpZMllUUmlPV1E1WTJVNVl6RXhZalkyWkRKaE5qWTNZeUlzSW1saGRDSTZNVGMwT0RZNU5UazFOU3dpWlhod0lqb3hOemd3TWpNeE9UVTFmUS4xT3BvV3ozWkdVNWdIZERBTUFTYWhqRlgtdnVublEtaDU0VnRxWFFLSzhZ',
    size: '200 x 240 cm',
    make: 'Organic Modern',
    isTopSeller: true,
  },
  {
    displayName: 'Bedside table in walnut',
    description: 'Bedside table in walnut',
    image: bedside_table_walnut_138x102,
    type: 'bedside_table',
    id: '66b2128dce9c11b66d2a9b5d',
    url: 'https://vectraxd.com/published/ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmtaWE5wWjI1SlpDSTZJalkyWWpJeE1qaGtZMlU1WXpFeFlqWTJaREpoT1dJMVpDSXNJbkJ5YjJwbFkzUkpaQ0k2SWpZMllUUmlPV1E1WTJVNVl6RXhZalkyWkRKaE5qWTNZeUlzSW1saGRDSTZNVGMwT0RZNU5qQXdOaXdpWlhod0lqb3hOemd3TWpNeU1EQTJmUS5VRDlheURrQWlpaWtWQzlWdml3S2dzRTZDQlcwNXJNUE1vVnphSVZvUDdn',
    size: '138 x 102 cm',
    make: 'Organic Modern',
    isTopSeller: true,
  },
  {
    displayName: 'Bedside table in oak',
    description: 'Bedside table in oak',
    image: bedside_table_oak_80x54,
    type: 'bedside_table',
    id: '66b212c5ce9c11b66d2a9b60',
    url: 'https://vectraxd.com/published/ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmtaWE5wWjI1SlpDSTZJalkyWWpJeE1tTTFZMlU1WXpFeFlqWTJaREpoT1dJMk1DSXNJbkJ5YjJwbFkzUkpaQ0k2SWpZMllUUmlPV1E1WTJVNVl6RXhZalkyWkRKaE5qWTNZeUlzSW1saGRDSTZNVGMwT0RZNU5qQXlNQ3dpWlhod0lqb3hOemd3TWpNeU1ESXdmUS5SckZXZFhzeWpkWWlFTkhOWUZHLUNHbGVDYVhrSlVQMHRUM2xmNzdTeWt3',
    size: '80 x 54 cm',
    make: 'Organic Modern',
    isTopSeller: true,
  },
  {
    displayName: 'Bedside table in grey',
    description: 'Bedside table in grey',
    image: bedside_table_black_54x67,
    type: 'bedside_table',
    id: '66b21305ce9c11b66d2a9b68',
    url: 'https://vectraxd.com/published/ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmtaWE5wWjI1SlpDSTZJalkyWWpJeE16QTFZMlU1WXpFeFlqWTJaREpoT1dJMk9DSXNJbkJ5YjJwbFkzUkpaQ0k2SWpZMllUUmlPV1E1WTJVNVl6RXhZalkyWkRKaE5qWTNZeUlzSW1saGRDSTZNVGMwT0RZNU5qQTFPU3dpWlhod0lqb3hOemd3TWpNeU1EVTVmUS5JdFNJXzF0dTdQSE9qblRydmU4Tm50Ukw2ajdSYTR3azhTUTBpS2thMEg4',
    size: '54 x 67 cm',
    make: 'Organic Modern',
    isTopSeller: true,
  },
  {
    displayName: 'Vinyl storage in walnut',
    description: 'Vinyl storage in walnut',
    image: vinyl_storage_walnut_249x136,
    type: 'vinyl_storage',
    id: '66ab3835ce9c11b66d2a814d',
    url: 'https://vectraxd.com/published/ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmtaWE5wWjI1SlpDSTZJalkyWVdJek9ETTFZMlU1WXpFeFlqWTJaREpoT0RFMFpDSXNJbkJ5YjJwbFkzUkpaQ0k2SWpZMllUUmlPV1E1WTJVNVl6RXhZalkyWkRKaE5qWTNZeUlzSW1saGRDSTZNVGMwT0RZNU5qRTRPU3dpWlhod0lqb3hOemd3TWpNeU1UZzVmUS4wTkVWcXVmcGpHWjZhRE5GYUZnMTB3cGlHOHVGRFRSeTZFTmhTemo0aERR',
    size: '249 x 136 cm',
    make: 'Organic Classic',
    isTopSeller: true,
  },
  {
    displayName: 'Vinyl storage in oak',
    description: 'Vinyl storage in oak',
    image: vinyl_storage_oak_153x111,
    type: 'vinyl_storage',
    id: '66ab31dcce9c11b66d2a7f5a',
    url: 'https://vectraxd.com/published/ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmtaWE5wWjI1SlpDSTZJalkyWVdJek1XUmpZMlU1WXpFeFlqWTJaREpoTjJZMVlTSXNJbkJ5YjJwbFkzUkpaQ0k2SWpZMllUUmlPV1E1WTJVNVl6RXhZalkyWkRKaE5qWTNZeUlzSW1saGRDSTZNVGMwT0RZNU5qRTNNU3dpWlhod0lqb3hOemd3TWpNeU1UY3hmUS5ZOWxDQldqZjdudUVlQVg3OXFWVzNxVTNscm5HNEx1ZTVsbmFaUTFMU09V',
    size: '153 x 111 cm',
    make: 'Organic Modern',
    isTopSeller: true,
  },
  {
    displayName: 'Vinyl storage in white color',
    description: 'Vinyl storage in white color',
    image: vinyl_storage_white_123x111,
    type: 'vinyl_storage',
    id: '66ab2eb6ce9c11b66d2a7f15',
    url: 'https://vectraxd.com/published/ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmtaWE5wWjI1SlpDSTZJalkyWVdJeVpXSTJZMlU1WXpFeFlqWTJaREpoTjJZeE5TSXNJbkJ5YjJwbFkzUkpaQ0k2SWpZMllUUmlPV1E1WTJVNVl6RXhZalkyWkRKaE5qWTNZeUlzSW1saGRDSTZNVGMwT0RZNU5qRTBNeXdpWlhod0lqb3hOemd3TWpNeU1UUXpmUS4xT01DbEVPSnJjSkFMam1uMk9XbHFrSXZkRTNjX1E3bkkyQUM3aDJUbmVB',
    size: '123 x 111 cm',
    make: 'Organic Modern',
    isTopSeller: true,
  },
  {
    displayName: 'Vinyl storage in black plywood color',
    description: 'Vinyl storage in black plywood color',
    image: vinyl_storage_black_155x111,
    type: 'vinyl_storage',
    id: '66ab3b10ce9c11b66d2a81a8',
    url: 'https://vectraxd.com/published/ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmtaWE5wWjI1SlpDSTZJalkyWVdJellqRXdZMlU1WXpFeFlqWTJaREpoT0RGaE9DSXNJbkJ5YjJwbFkzUkpaQ0k2SWpZMllUUmlPV1E1WTJVNVl6RXhZalkyWkRKaE5qWTNZeUlzSW1saGRDSTZNVGMwT0RZNU5qSXhOU3dpWlhod0lqb3hOemd3TWpNeU1qRTFmUS5DVU9RUjRYVzNDelR0RkxrSTBhRktUNTFCTkJ1M3c1bWx3WHBLSDN6dEZ3',
    size: '155 x 111 cm',
    make: 'Organic Modern',
    isTopSeller: true,
  },
]
